export default __webpack_public_path__ + "static/s4-3f8d8365ada1a1c04ccda37b553914cc.webp";